export default __webpack_public_path__ + "static/media/ionicons.8b4d7ad8.eot";